var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g3, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 781.92 900.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.92 259.95l88.27 51.6c25.31 18.02 37.69 35.89 42.18 60.62.37 39.47.74 78.94 1.1 118.4.65 34.53-11.06 60.62-35.96 77.71-31.11 17.53-62.23 35.06-93.34 52.59-10.64 5.99-23.82 8.66-36.98 8.57-13.16.09-26.34-2.58-36.98-8.57-31.11-17.53-62.23-35.06-93.34-52.59-24.9-17.09-36.61-43.19-35.96-77.71.37-39.47.74-78.94 1.1-118.4 4.5-24.74 16.87-42.61 42.18-60.62l88.27-51.6c11.59-6.77 23.23-9.79 34.72-9.73 11.5-.06 23.13 2.96 34.72 9.73z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.54 624.84c-8.76 3.22-18.56 4.67-28.34 4.61-10.37.07-20.75-1.57-29.89-5.2 5.25-.76 7.6-1.81 12.82-3.99 8.13 1.87 20.06-1.34 24.94-10.17 4.96 8.73 11.32 14.6 20.47 14.75z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.3 372.17c4.5-24.74 16.87-42.61 42.18-60.62",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.03 385.25L238.9 526.2c-2.99-8.64-4.7-17.62-4.7-26.11v-49.36l49.7-86.34c10.19 5.88 20.38 11.77 30.57 17.65l5.57 3.22zm-40.27-23.74c-2.66-1.37-5.31-2.74-7.97-4.12 5.15-2.44 10.65-4.5 16.89-5.73 3.1 1.63 6.2 3.27 9.3 4.9-6.73 1.06-13.3 2.28-18.22 4.95zm-1.37-15.81c-6.53-3.61-10.57-8.71-11.28-15.81-8.24 5.5-13.63 13.29-17.27 22.49 5.99-1.11 11.19-.35 15.78 1.83 2.89-3.76 6.78-6.85 12.77-8.51zm70.77 56.37l-34.06 59.18c35.34 36.13 11 78.01-18.17 76.07-8.2-.54-13.82-5.2-19.23-11.1l-18.99 32.98c3.6 3.68 7.45 6.77 11.45 9.08l44.31 25.58c14.76 8.52 29.54 17.05 44.32 25.59 1.32.76 2.63 1.42 3.91 1.98l32.09-55.75v-89.74c0-26.12-16.24-56.9-36.04-68.33l-9.6-5.54z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M566.37 372.17c-4.5-24.74-16.87-42.61-42.18-60.62",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M500.86 538.02c15.67-.14 31.16-18.34 33.77-35.12 2.62-16.78-.59-32.86-10.11-38.22l-3.31-10.11 24.98-102.43c12.53.22 21.29 11.83 21.29 31.05v12.99l-42.96 176.14-37.28 21.52 13.61-55.83zm8.33-168.67l-11.02 6.36-22.95 94.1 3.11-3.25 1.25 2.73c2.1-2.81 4.46-5.26 7-7.28l22.6-92.67zm-28.6 16.51l-25.66 105.23c-4.75 6-6.59 15.41-5.92 24.26l-26.23 107.56c-9.57-3.03-15.89-13.82-15.89-30.13v-52.79l31.57-129.43c1.47-1.09 2.96-2.08 4.47-2.95 12.56-7.25 25.12-14.5 37.67-21.75zm-42.43 235.91a36.12 36.12 0 004.73-2.32l6.17-3.56 19.03-78.04c-3.51 1-6.59.49-9.2-1.09l-20.73 85.01zM370.42 398.95l-92.03-53.25c-16.73-9.68-14.63-26.74 4.67-37.9l82.7-47.85c20.84-12.06 49.33-12.06 70.17 0l82.7 47.85c19.3 11.17 21.4 28.22 4.67 37.9l-92.03 53.25c-15.41 8.92-45.42 8.92-60.84 0zm71.31-115.04c-10.77-20.22-64.19-21.74-79.89-3.2l-4.93 12.31-.57-5.18-21.53 1.09c-18.19.92-47.83 25.63-27.63 34.09l55.26 22.88.05-2.15c11.61 4.86 26.38 6.81 35.83 7.13 19.54.66 57.84-6.16 59.04-26.65-5.21-13.44-10.42-26.88-15.62-40.32z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.06 535.63l.02-.04c-.37-.2-.73-.42-1.08-.66l-11.69-6.72c-13.65-7.85-13.93-27.9-10.18-41.24 5.37-19.13 19.46-32.67 32.46-31.9 3.31.2 5.48 1.18 8.37 2.76l11.56 6.3c.29.16.66.43 1.03.73-2.74-13.12-10.1-22.86-20.78-25.29-18.23-4.15-39.22 14.57-46.87 41.83-7.65 27.26.93 52.72 19.16 56.88 5.89 1.34 12.07.3 17.99-2.65z",
    fill: "#6d6f7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.06 535.63l.02-.04c-.37-.2-.73-.42-1.08-.66l-6.75-3.88-15 5.54c1.52.74 3.13 1.31 4.83 1.7 5.89 1.34 12.07.3 17.99-2.65zm-11.19-70.4c6.16-6.72 13.6-10.59 20.72-10.16 3.31.2 5.48 1.18 8.37 2.76l11.56 6.3c.29.16.66.43 1.03.73-2.74-13.12-10.1-22.86-20.78-25.29-18.23-4.15-39.22 14.57-46.87 41.83-.91 3.24-1.59 6.46-2.05 9.62l27.07-27.15.95 1.35z",
    fill: "#babac1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M482.63 501.71l-1.51 14.87-10.77-6.22-.73-16.16 13.01 7.51z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M485.4 463.36l9.12-7.83 14.32 8.18-10.64 6.97-12.81-7.33zm-8.93 10.6l13.01 7.36 5.31-6.59-13.97-7.91-4.35 7.14z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M526.39 465.1l9.29 20.48-32.21-2.46-3.69-16.15 15.39-4.39 11.22 2.52z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M510.45 536.34l-19.98-.43-6.74-14.59-2.21-13.53 9.1-4.2 19.83 32.75zm15.79-13.94l-31.95-28.02-3.04 6.18 24.25 32.59 10.75-10.75z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M487.41 529.29c8.7 9.28 22.07 10.23 31.75 1.3 10.65-9.82 20.79-30.05 16.13-47.56-1.55-5.82-5.22-11.63-11.92-18.61l-.91 4.53c7.49 13.88 4.99 29.93-.08 40.3-7.37 15.07-15.86 25.15-34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M528.02 467.83c-2.1-1.38-3.88-2.62-4.64-3.4l-2.59-.59 1.68 5.11c2.79 5.16 4.19 10.62 4.59 15.97l4.38.33 5.15.39c-.88-7.36-4.44-13.69-8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M483.25 520.96c1.67 1.3 3.56 2.23 5.66 2.71 11.47 2.61 24.66-9.16 29.47-26.3 4.15-14.8.7-28.75-7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.08 510.2c.98.63 2.05 1.08 3.21 1.35 8.13 1.85 17.5-6.5 20.91-18.66 3-10.7.4-20.77-5.81-24.31-7.06 5.63-13.1 14.84-16.21 25.93-1.52 5.41-2.19 10.73-2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M496.87 492.83l19.85 9.45M503.89 486.44l16.02 2.94M503.31 478.9l16.23-.68M501.37 472.87l13.83-3.82"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M483.23 502.19c.64.41 1.34.71 2.1.88 5.32 1.21 11.43-4.25 13.66-12.2 1.96-6.99.26-13.58-3.8-15.88-4.61 3.68-8.56 9.7-10.6 16.95-.99 3.54-1.43 7.01-1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M487.41 529.29c3.21 3.43 7.07 5.72 11.14 6.8l9.92.21c.56-.12 1.13-.27 1.69-.44l-4.29-7.09c-4.86 2.17-10.8 2.56-18.45.52zm38.67-6.73l.13-.18-7.39-6.48c-2.5 4.17-5.25 7.68-8.56 10.23l5.23 7.03 10.59-10.6z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M509.8 514.11l-13.56-12.9M500.9 521.65l-9.9-15.1M491.53 524.02l-5.45-15.69"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M519.46 463.01c-13.73-3.13-29.53 10.97-35.29 31.49-5.76 20.52.7 39.69 14.43 42.82 13.73 3.13 29.53-10.97 35.29-31.49 5.76-20.52-.7-39.69-14.43-42.82z",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M503.59 455.07c-13-.78-27.09 12.77-32.46 31.9-3.74 13.34-3.47 33.4 10.18 41.24l11.69 6.72c1.72 1.13 3.58 1.94 5.6 2.4 13.73 3.13 29.53-10.97 35.29-31.49 4.7-16.74 1.26-32.58-7.61-39.55-.82-.64-2-1.74-2.75-2.15l-11.56-6.3c-2.89-1.58-5.06-2.57-8.37-2.76z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M488.14 529.34c1.25.68 2.6 1.19 4.03 1.51 12.88 2.94 27.71-10.3 33.12-29.56 4.61-16.42.88-31.91-8.29-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M494.06 535.63l.02-.04c-.37-.2-.73-.42-1.08-.66l-11.69-6.72c-13.65-7.85-13.93-27.9-10.18-41.24 5.37-19.13 19.46-32.67 32.46-31.9 3.31.2 5.48 1.18 8.37 2.76l11.56 6.3c.29.16.66.43 1.03.73-2.74-13.12-10.1-22.86-20.78-25.29-18.23-4.15-39.22 14.57-46.87 41.83-7.65 27.26.93 52.72 19.16 56.88 5.89 1.34 12.07.3 17.99-2.65z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M406.88 536.39l48-27.71m72.34-41.77l40.26-23.25M438.15 440.1c-3.2-.73-6.88 2.56-8.23 7.34-1.34 4.79.16 9.25 3.36 9.98 3.2.73 6.88-2.56 8.23-7.34 1.34-4.79-.16-9.25-3.36-9.98zM438.15 583.44c-3.2-.73-6.88 2.56-8.23 7.34-1.34 4.78.16 9.25 3.36 9.98 3.2.73 6.88-2.56 8.23-7.34 1.34-4.78-.16-9.25-3.36-9.98zM544.79 379.86c-3.2-.73-6.88 2.56-8.23 7.34-1.34 4.78.16 9.25 3.36 9.98 3.2.73 6.88-2.56 8.23-7.34 1.34-4.78-.16-9.25-3.36-9.98zM544.79 523.21c-3.2-.73-6.88 2.56-8.23 7.34-1.34 4.78.16 9.25 3.36 9.98 3.2.73 6.88-2.56 8.23-7.34 1.34-4.78-.16-9.25-3.36-9.98z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M372.96 347.14l-20.35-9.16 13.22-40.14 16.92 7.03-9.79 42.27zm15 2.77l6.21-43.38-5.6-.59-8.62 42.82 8.01 1.15z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M420.78 304.43l10.01-3.58 16.26 38.58-13.24 6.24-13.02-41.25zm-11.4 2.87l7.19 41.35 8.17-1.3-10.01-40.58-5.36.52z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M456.03 320.84c.21.55 1.32 3.63 1.31 3.75-.42 14.41-25.55 26.03-56.49 26.03s-56.5-11.82-56.5-26.4",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M345.64 320.97c-.21.55-1.32 3.63-1.31 3.75.42 14.41 25.55 26.03 56.49 26.03s56.5-11.82 56.5-26.4",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M442.39 287.39c-5.43 16.7-28.94 19.33-42.22 19.42-14.24.09-38.36-4.84-40.17-20.26-2.14 4.69-4.29 9.37-6.43 14.06 11.56 15.96 29.98 18.54 45.95 18.64 15.39.1 39.32-3.51 48.09-17.37l-5.22-14.49z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M394.16 306.58c-1.68-.13-3.41-.33-5.18-.59l-.41-.04-2.51 12.45c2.11.29 4.22.49 6.32.62l1.78-12.44zm-11.97-1.94c-5.04-1.26-9.91-3.13-13.81-5.74l-2.55-1.06-3.77 11.46c5.41 4.07 11.52 6.52 17.82 7.97l2.87-12.4-.55-.23z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M428.32 301.73c-2.14.96-4.4 1.75-6.71 2.4l-.84.3 3.73 11.81c3.88-1.04 7.63-2.38 11.04-4.09l-4.76-11.29-2.46.88zm-16.97 16.91a95.1 95.1 0 006.1-.86l-2.71-10.99-5.36.52 1.97 11.34z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M355.6 296.23c-.18.42-1.08 2.81-1.08 2.9.34 11.13 20.98 20.11 46.38 20.11s46.38-9.13 46.38-20.39",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M370.25 289.21c-1.8 1.43-3.24 3-4.27 4.66l-1.37 2.23-1.73-1.98c-.94-1.07-1.66-2.18-2.15-3.32-.51-1.18-.77-2.4-.77-3.63 0-2.61 1.17-5.09 3.29-7.36 2.01-2.15 4.92-4.11 8.5-5.78 3.81-1.78 8.36-3.21 13.4-4.18 4.84-.93 10.14-1.44 15.7-1.44s10.86.51 15.7 1.44c5.04.97 9.59 2.4 13.4 4.18 3.58 1.67 6.49 3.64 8.5 5.78 2.12 2.26 3.29 4.75 3.29 7.36 0 1.24-.27 2.45-.77 3.63-.49 1.14-1.21 2.25-2.15 3.32l-1.73 1.98-1.37-2.23c-1.02-1.67-2.47-3.23-4.28-4.67-1.88-1.5-4.15-2.84-6.73-4-3.25-1.46-7.01-2.64-11.1-3.43-3.97-.77-8.27-1.19-12.76-1.19s-8.8.42-12.77 1.2c-4.11.8-7.87 1.98-11.12 3.44-2.57 1.16-4.83 2.5-6.71 4z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M427.61 273.02c.81.32 1.59.66 2.34 1.01 3.58 1.67 6.49 3.64 8.5 5.78 2.12 2.26 3.29 4.75 3.29 7.36 0 1.24-.27 2.45-.77 3.63-.49 1.14-1.21 2.25-2.15 3.32l-1.73 1.98-1.37-2.23c-1.02-1.67-2.47-3.23-4.28-4.67-1.88-1.5-4.15-2.84-6.73-4-.68-.31-1.39-.6-2.11-.88l5.01-11.29z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M400.84 389.57c5.02 0 9.11-1.91 9.11-4.25s-4.09-4.25-9.11-4.25-9.11 1.91-9.11 4.25 4.09 4.25 9.11 4.25zM392.66 267.41c-.6-.57-.94-1.21-.94-1.88 0-2.35 4.08-4.25 9.11-4.25s9.11 1.9 9.11 4.25c0 .46-.16.9-.44 1.31M509.9 331.47c5.02 0 9.11-1.91 9.11-4.25s-4.09-4.25-9.11-4.25-9.11 1.91-9.11 4.25 4.09 4.25 9.11 4.25zM291.78 331.47c5.02 0 9.11-1.91 9.11-4.25s-4.09-4.25-9.11-4.25-9.11 1.91-9.11 4.25 4.09 4.25 9.11 4.25z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M400.85 290.01c12.57 0 22.76 4.76 22.76 10.64 0 1.16-.4 2.27-1.13 3.32-6.3 1.8-13.71 2.84-21.63 2.84s-15.33-1.04-21.63-2.84c-.73-1.04-1.13-2.16-1.13-3.32 0-5.87 10.19-10.64 22.76-10.64z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M487.52 366.4l-24.45-14.12M465.87 277.28l-21.83 12.61M334.49 278.04l23.26 13.43"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M548.63 421.38l9.26-5.34v21.52l-9.26 5.35v-21.53zM548.63 465.81l9.26-5.35v21.53l-9.26 5.34v-21.52z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M394.79 536.39l-48-27.71m-72.34-41.77l-40.26-23.25M363.52 440.1c3.2-.73 6.88 2.56 8.23 7.34 1.34 4.79-.16 9.25-3.36 9.98-3.2.73-6.88-2.56-8.23-7.34-1.34-4.79.16-9.25 3.36-9.98zM363.52 583.44c3.2-.73 6.88 2.56 8.23 7.34 1.34 4.78-.16 9.25-3.36 9.98-3.2.73-6.88-2.56-8.23-7.34-1.34-4.78.16-9.25 3.36-9.98zM256.88 523.21c3.2-.73 6.88 2.56 8.23 7.34 1.34 4.78-.16 9.25-3.36 9.98-3.2.73-6.88-2.56-8.23-7.34-1.34-4.78.16-9.25 3.36-9.98z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M382.45 496.1l-9.26-5.35v21.53l9.26 5.34V496.1zM382.45 540.53l-9.26-5.35v21.52l9.26 5.35v-21.52z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8 459.29c-3.02-8.29-4.08-11.76-7.1-20.05 12.46-6.22 18.08-18.1 17.22-33.62 6.59-1 13.17-2.01 19.75-3.01 3.36 26.99-13.95 51.94-29.86 56.68z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370.42 398.95l-92.03-53.25c-16.73-9.68-14.63-26.74 4.67-37.9l82.7-47.85c20.84-12.06 49.33-12.06 70.17 0l82.7 47.85c19.3 11.17 21.4 28.22 4.67 37.9l-92.03 53.25c-15.41 8.92-45.42 8.92-60.84 0z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M385.37 293.71l-8.62 8.66-5.78-13.71c1.73-1.28 3.74-2.44 6-3.45 1.59-.72 3.3-1.36 5.11-1.93l3.29 10.43zm12.54-2.18l-5.97-.07-2.45-9.95c2.1-.36 4.29-.62 6.55-.78l1.88 10.79z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M370.97 288.66l-4.8-11.39c.94-.68 1.98-1.34 3.1-1.97l5.15-2.41c1.25-.49 2.57-.95 3.94-1.37l3.71 11.75c-1.81.57-3.52 1.21-5.11 1.93-2.25 1.01-4.27 2.17-6 3.45zm15.58-19.06c2.37-.41 4.84-.72 7.39-.92l2.09 12.05c-2.26.16-4.44.42-6.55.78l-2.94-11.91z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M400.84 372.71c-50.33 0-91.14-20.25-91.14-45.23 0-17.54 20.11-32.74 49.51-40.24l-3.05 7.56c-.28.08-.55.17-.83.25l-3.1 8.32c-2.34 1.34-4.49 2.87-6.6 4.44l-11.54-3.3c-9.91 6.34-15.77 14.14-15.77 22.58 0 5.85 2.81 11.39 7.83 16.35l13.61-3.65c5.07 4 10.71 6.86 16.74 8.97l-2.53 9.95c13.31 4.28 29.45 6.8 46.86 6.8s33.55-2.51 46.86-6.8l-2.53-9.95c6.03-2.1 11.67-4.96 16.74-8.97l13.61 3.65c5.02-4.96 7.83-10.5 7.83-16.35 0-8.44-5.85-16.25-15.77-22.58l-11.54 3.3c-2.11-1.57-4.26-3.1-6.6-4.44l-3.1-8.32c-.27-.08-.55-.17-.83-.25l-3.05-7.56c29.4 7.5 49.51 22.71 49.51 40.24 0 24.98-40.8 45.23-91.14 45.23z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M309.94 324.18c2.34-16.13 21.73-29.91 49.27-36.94l-3.05 7.56c-.28.08-.55.17-.83.25l-3.1 8.32c-2.34 1.34-4.49 2.87-6.6 4.44l-11.54-3.3c-9.91 6.34-15.77 14.14-15.77 22.58v.6l-8.4-3.52z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M423.15 302.8c-.4-3.47-1.71-6.51-4.82-8.69l4.61-10.38c5.99 2.85 10.96 6.04 15.01 11.99-3.78 3.89-9.41 6.89-14.79 7.08z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M364.36 296.92c2.71-9.31 18.02-16.45 36.5-16.45s33.75 7.12 36.48 16.41",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6f7a",
    fillRule: "evenodd",
    d: "M509.18 369.35l-41.45 24.37v37.11l41.44-23.49.01-37.99z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M509.18 369.35l-11.05 6.5-10.68 43.81 10.98-6.23 10.75-44.08zm-28.68 16.86l-12.77 7.51v37.11l2.2-1.25 10.58-43.37z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M509.17 407.34v-37.11M467.73 430.83v-37.11M502.73 410.74l-6.27-5.31-13.47 7.64-6.31 12.43"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6f7a",
    fillRule: "evenodd",
    d: "M467.38 604.43v-32.45l41.44-23.49-.1 32.96-41.34 22.98z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#45454d",
    d: "M292.49 369.35l41.45 24.37v37.11l-41.44-23.49-.01-37.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d6f7a",
    d: "M319.91 385.47l14.03 8.25v34.77l-1.01 1.77-29.26-16.59 16.24-28.2z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#45454d",
    fillRule: "evenodd",
    d: "M334.29 604.43v-32.45l-41.44-23.49.1 32.96 41.34 22.98z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#babac1",
    fillRule: "evenodd",
    d: "M487.37 593.31l9.25-37.9 12.2-6.92-.1 32.96-21.35 11.86z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M475.14 567.92l6.27 5.3 13.47-7.64 6.31-12.43M467.38 605.79v-33.81M536.4 494.13l1.83-3.6.15-58.45-29.21-24.74-41.44 23.49-29.41 57.96-.14 58.45 29.2 24.74 41.44-23.51 7.85-15.48M508.82 581.08v-32.59"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M531.49 356.47c-14.75 8.51-29.52 17.05-44.28 25.57-14.76 8.52-29.52 17.04-44.29 25.57-19.8 11.43-36.04 42.21-36.04 68.33v116.85c0 26.12 16.22 38.09 36.01 26.67 14.79-8.54 29.57-17.06 44.32-25.59l44.31-25.58c19.8-11.43 35.96-42.08 35.96-68.2V383.2c0-26.12-16.17-38.17-35.99-26.73z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M265.27 494.13l-1.82-3.6-.16-58.45 29.21-24.74 41.44 23.49 29.41 57.96.14 58.45-29.2 24.74-41.44-23.51-7.85-15.48M333.94 430.83v-37.11"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M270.18 356.47c14.75 8.51 29.52 17.05 44.28 25.57 14.76 8.52 29.52 17.04 44.29 25.57 19.8 11.43 36.04 42.21 36.04 68.33v116.85c0 26.12-16.22 38.09-36.01 26.67-14.79-8.54-29.57-17.06-44.32-25.59l-44.31-25.58c-19.8-11.43-35.96-42.08-35.96-68.2V383.2c0-26.12 16.17-38.17 35.99-26.73z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M292.5 407.34v-37.11M334.29 605.79v-33.81M292.85 581.08v-32.59M324.99 567.04l-6.26 5.31-13.48-7.64-6.3-12.43M312.84 365.64l24.41-14.1M256.88 379.86c3.2-.73 6.88 2.56 8.23 7.34 1.34 4.78-.16 9.25-3.36 9.98-3.2.73-6.88-2.56-8.23-7.34-1.34-4.78.16-9.25 3.36-9.98zM298.95 410.74l6.26-5.31 13.47 7.64 6.31 12.43M448.21 358.53l-3.05-9.76c5.9-2.12 13.21-5.7 16.74-8.97l13.42 3.77"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M443.38 287.24c28.87 7.61 48.54 22.72 48.54 40.11 0 25.05-40.78 45.35-91.08 45.35s-91.08-20.31-91.08-45.35c0-17.73 20.43-33.08 50.2-40.54",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M445.68 294.6c22.67 6.87 37.67 18.8 37.67 32.36 0 21.29-36.94 38.55-82.51 38.55s-82.51-17.26-82.51-38.55c0-13.44 14.72-25.27 37.03-32.17",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M449.44 303.38c2.65 1.44 5.01 2.97 6.6 4.44l11.85-3.33M352.23 303.38c-2.65 1.44-5.01 2.97-6.6 4.44l-11.85-3.33M353.46 358.53l3.05-9.76c-5.9-2.12-13.21-5.7-16.74-8.97l-13.42 3.77",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M359.57 285.2l-14.61 37.64M442.1 285.07l14.61 37.64M400.85 290.01c12.57 0 22.76 4.76 22.76 10.64 0 1.16-.4 2.27-1.13 3.32-6.3 1.8-13.71 2.84-21.63 2.84s-15.33-1.04-21.63-2.84c-.73-1.04-1.13-2.16-1.13-3.32 0-5.87 10.19-10.64 22.76-10.64z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M400.85 306.8c22.88 0 41.54-8.72 41.54-19.41s-18.66-19.41-41.54-19.41-41.54 8.72-41.54 19.41 18.66 19.41 41.54 19.41z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M438.12 621.79c-21.3 9.82-55.63 10.67-75.84-.54",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M423.46 515.95c1.35-.78 2.58-1.06 3.46-.89.89.17 1.44.79 1.44 1.82v14.08c0 1.03-.55 2.29-1.44 3.49a11.99 11.99 0 01-3.46 3.1c-1.35.78-2.58 1.07-3.47.9-.89-.17-1.44-.79-1.44-1.83v-14.08c0-1.03.55-2.29 1.44-3.49.89-1.19 2.12-2.33 3.47-3.11zM248.85 441.32c-1.35-.78-2.58-1.06-3.46-.89-.89.17-1.44.79-1.44 1.82v14.08c0 1.03.55 2.29 1.44 3.49a11.99 11.99 0 003.46 3.1c1.35.78 2.58 1.07 3.47.9.89-.17 1.44-.79 1.44-1.83v-14.08c0-1.03-.55-2.29-1.44-3.49-.89-1.19-2.12-2.33-3.47-3.1z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.61 535.63l-.02-.04c.37-.2.73-.42 1.08-.66l11.69-6.72c13.65-7.85 13.92-27.9 10.18-41.24-5.37-19.13-19.46-32.67-32.46-31.9-3.31.2-5.48 1.18-8.37 2.76l-11.56 6.3c-.3.16-.66.43-1.04.73 2.74-13.12 10.1-22.86 20.78-25.29 18.23-4.15 39.22 14.57 46.87 41.83 7.65 27.26-.93 52.72-19.16 56.88-5.89 1.34-12.07.3-17.99-2.65z",
    fill: "#6d6f7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.45 527.53c8.5-5.59 11.32-16.24 11.14-26.56.26-7.82-1.61-16.31-6.29-24.85-2.34-4.54-5.18-8.52-8.33-11.77a81.87 81.87 0 00-2.87-3.11l8.19-14.23c9.35 7.49 17.35 19.7 21.48 34.39 7.65 27.26-.93 52.72-19.16 56.88-5.71 1.3-11.7.36-17.46-2.4 4.96-1.63 9.52-4.51 13.32-8.36z",
    fill: "#45454d"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M282.22 461.92c4.97-.03 7.83.27 14.35 3.44l13.01-7.46c-6-3.31-11.38-3.68-15.85-1.96l-11.51 5.98z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 515.27l9.77 11.56 29.65-18.89-12.52-8.86-26.9 16.18zm-3.4-11.77l30.66-15.96.94 8.05-29.82 14.47-1.77-6.56z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M291.87 514.11l13.56-12.9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M328.79 484.31l-4.04-10.74-12.97 7.41 5.02 10.18 11.98-6.86zm3.48 13.68l-12.65 7.16-1.83-8.56 13.61-7.71.87 9.11z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M275.28 465.1l-9.29 20.48 32.21-2.46 3.69-16.15-15.39-4.39-11.22 2.52z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M314.27 529.29c-8.7 9.28-22.07 10.23-31.75 1.3-10.65-9.82-20.79-30.05-16.13-47.56 1.55-5.82 5.22-11.63 11.92-18.61l.91 4.53c-7.49 13.88-5 29.93.08 40.3 7.37 15.07 15.86 25.15 34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M273.66 467.83c4.05-2.66 3.54-2.82 8.33-3.67l-2.77 4.79c-2.79 5.16-4.19 10.62-4.59 15.97l-4.38.33-5.15.39c.88-7.36 4.44-13.69 8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M318.43 520.96c-1.67 1.3-3.56 2.23-5.66 2.71-11.47 2.61-24.66-9.16-29.47-26.3-4.15-14.8-.7-28.75 7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 510.2c-.98.63-2.05 1.08-3.21 1.35-8.13 1.85-17.5-6.5-20.91-18.66-3-10.7-.4-20.77 5.81-24.31 7.06 5.63 13.1 14.84 16.21 25.93 1.52 5.41 2.19 10.73 2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M304.8 492.83l-19.85 9.45M297.79 486.44l-16.03 2.94M298.36 478.9l-16.23-.68M300.3 472.87l-13.83-3.82"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M318.45 502.19c-.64.41-1.34.71-2.1.88-5.32 1.21-11.43-4.25-13.66-12.2-1.96-6.99-.26-13.58 3.8-15.88 4.62 3.68 8.56 9.7 10.6 16.95.99 3.54 1.43 7.01 1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M300.77 521.65l9.9-15.1M310.15 524.02l5.44-15.69"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M282.21 463.01c13.73-3.13 29.53 10.97 35.29 31.49 5.76 20.52-.7 39.69-14.43 42.82s-29.53-10.97-35.29-31.49c-5.76-20.52.7-39.69 14.43-42.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 515.27l9.77 11.56 7.18-4.57-7.09-9.09-1.25-3.07-8.61 5.18zm4.29-15.77l2.62 6.42-8.54 4.14-1.77-6.56 7.69-4z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M313.53 529.34c-1.25.68-2.6 1.19-4.03 1.51-12.89 2.94-27.71-10.3-33.12-29.56-4.61-16.42-.88-31.91 8.29-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M298.08 455.07c13-.78 27.09 12.77 32.46 31.9 3.74 13.34 3.47 33.4-10.18 41.24l-11.69 6.72a16.995 16.995 0 01-5.6 2.4c-13.73 3.13-29.53-10.97-35.29-31.49-4.7-16.74-1.26-32.58 7.61-39.55.82-.64 2-1.74 2.75-2.15l11.56-6.3c2.89-1.58 5.06-2.57 8.37-2.76z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M307.61 535.63l-.02-.04c.37-.2.73-.42 1.08-.66l11.69-6.72c13.65-7.85 13.92-27.9 10.18-41.24-5.37-19.13-19.46-32.67-32.46-31.9-3.31.2-5.48 1.18-8.37 2.76l-11.56 6.3c-.3.16-.66.43-1.04.73 2.74-13.12 10.1-22.86 20.78-25.29 18.23-4.15 39.22 14.57 46.87 41.83 7.65 27.26-.93 52.72-19.16 56.88-5.89 1.34-12.07.3-17.99-2.65z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest1);
export default __webpack_public_path__ + "static/media/test1.287ab65d45d6c58cad34c46755bedb75.svg";
export { ForwardRef as ReactComponent };